import React, { useEffect, useState } from "react";
import Benefits from "../../common/Benefits";
import { whatsapp_business_services, WhatsappBusinessdata } from "../../common/data";
import Joinus from "../../common/Joinus";
import { initialStates, servicescontent, whatsappBusinessApiFAQs, whatsappServiceDetails } from "../home/Constant";
import MetaService from "./MetaService";
import WhatWeDo from "./WhatWeDo";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import OwlCarousel from "react-owl-carousel3";
import benefiticon from "../../assets/images/Benefits icon 1 (1).webp"
import { Helmet } from "react-helmet";


const WhatsappBusinessApi = () => {
  const [showAll, setShowAll] = useState(false);
  const colors = ["#ffc250", "#e9536c", "#f4b1b8", "#1eacc0"];
  useEffect(() => {
    const handleScroll = () => {
      const currentY = window.scrollY;
      console.log(`Scr ${currentY.toFixed(0)}px`);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const itemsToShow = showAll ? whatsappBusinessApiFAQs : whatsappBusinessApiFAQs.slice(0, 10);
  const percentageData = [
    {
      per: "98%",
      name: "Open Rates"
    },
    {
      per: "45-60%",
      name: "Click Rates"
    },
    {
      per: "2.60Bn+",
      name: "Active Users"
    },
    {
      per: "70%",
      name: "Engagement Rate"
    }
  ]
  return (
    <>
        <Helmet>
      <meta name="keywords" content="WhatsApp Business API Provider,Official WhatsApp API Provider India,Business WhatsApp API Chennai,WhatsApp API Service Provider,WhatsApp API Provider in Chennai,whatsapp business api provider,whatsapp api provider,whatsapp button api"/> 
    </Helmet>
    <div className="margin-topall">
      <section className="py-5 service-position overflow-hidden">
        <div className="container">
          <div className="metaapi-bg-round">
            {colors.map((color, i) => (
              <div
                key={i}
                id={`dot_00${i}`}
                style={{
                  position: "absolute",
                  border: `${i == 0 ? "9px solid white" : "none"}`,
                  top: `${initialStates[i].top}px`,
                  left: `${initialStates[i].left}px`,
                  width: `${initialStates[i].width}px`,
                  height: `${initialStates[i].height}px`,
                  marginLeft: `${initialStates[i].marginLeft}px`,
                  opacity: initialStates[i].opacity,
                  backgroundColor: color,
                  borderRadius: "50%",
                  zIndex: 1000,
                  pointerEvents: "none",
                  willChange: "top, left, width, height, opacity, margin-left",
                }}
              />
            ))}
          </div>
          <div className="pos-z-index ">
            <div className="row justify-content-center"
              data-aos="fade-down" data-aos-delay="300"
            >
              <div className="col-lg-6">
                <div className="">
                  <h5 className="yellow-sub-heading text-center py-2">
                  WhatsApp Business API 
                  </h5>
                  {/* <h4 className="black-service-heading text-center font-align mt-3">
                    Unlock 5x Revenue Growth
                  </h4> */}
                  <div className="smsapi-sub-heading">
                  The WhatsApp Business API is a powerful tool designed for medium to large businesses that want to communicate with customers at scale through WhatsApp — using automation, integrations, and custom workflows. 
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <WhatWeDo data={whatsappServiceDetails}/>
      {/* <MetaService heading="WhatsApp Business Api" data={whatsapp_business_services} /> */}
      <div className="benefitsfont">benefits</div>
      <div className="benefithead">Business</div>
      <div className="mb-5">
                       <div className="container-fluid">
                         <div className="row">
                           <div className="col-lg-12">
                             <div className="benefitwidth">
                               <OwlCarousel
                                 className="owl-theme"
                                 loop
                                 autoplay={true}
                                 items="1"
                                 dots={false}
                                 smartSpeed={2000}
                                 nav={true}
                                 navText={[
                                   `<i class="fa fa-chevron-left"></i>`,
                                   `<i class="fa fa-chevron-right"></i>`,
                                 ]}
                                 margin={20}
                                 // center={true}
                                 autoplayTimeout={5000}
                                 responsive={{
                                   360: {
                                     items: "1",
                                   },
                                   414: {
                                     items: "1",
                                   },
                                   670: {
                                     items: "2",
                                   },
                                   992: {
                                     items: "3",
                                   },
         
                                   1200: {
                                     items: "3",
                                   },
                                 }}
                               >
                                 {whatsapp_business_services.map((item, index) => {
                                   return (
                                    <div className="position-circle">
                                       <img  src={benefiticon} className='benefiticon' alt='icon'/>
                                       <div className="border-dot1">
                                    <div className="orange-circle">
          
                                    </div>
                                    </div>
                                    <div className="carousel-wapp-card">
                                     
    <div>
      <div className="carouselwapp">
    {item.title}
      </div>
      <div className="carousel-para">
    {item.points}
      </div>
    </div>
    
                                    </div>
                                    </div>
                                    
                                   );
                                 })}
                               </OwlCarousel>
                             </div>
                           </div>
                         </div>
                       </div>
                     </div>
      <Benefits data={WhatsappBusinessdata} />
      <section className="py-5 ">
        <div className="container">
          <div className="feature_content"
            data-aos="fade-right" data-aos-delay="300"
          >
            <h4>How is WhatsApp Business API Different?</h4>
            <p>Here's how WhatsApp Business API is different from WhatsApp Business App</p>
          </div>
          <div className="table-scroll-wrapper">
            <table className="feature_table w-100 table-auto border-collapse border border-gray-400 text-left">
              <thead>
                <tr className="bg-gray-200">
                  <th className="border border-gray-400 p-2">Feature</th>
                  <th className="border border-gray-400 p-2">WhatsApp Business App<br /><small>For Small Businesses</small></th>
                  <th className="border border-gray-400 p-2">WhatsApp Business API<br /><small>For Growing Businesses</small></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="border border-gray-400 p-2">Send Bulk Notifications</td>
                  <td className="border border-gray-400 p-2">Not recommended, only 256 contacts at once. Chances of WhatsApp getting banned</td>
                  <td className="border border-gray-400 p-2">Setup custom automated messages on trigger keywords</td>
                </tr>
                <tr>
                  <td className="border border-gray-400 p-2">Multi-User Access</td>
                  <td className="border border-gray-400 p-2">Up to 5 Devices</td>
                  <td className="border border-gray-400 p-2">Unlimited Users</td>
                </tr>
                <tr>
                  <td className="border border-gray-400 p-2">WhatsApp Chatbots</td>
                  <td className="border border-gray-400 p-2">No Chatbot Integration</td>
                  <td className="border border-gray-400 p-2">Yes</td>
                </tr>
                <tr>
                  <td className="border border-gray-400 p-2">Automated Messaging</td>
                  <td className="border border-gray-400 p-2">Not Possible</td>
                  <td className="border border-gray-400 p-2">Yes</td>
                </tr>
                <tr>
                  <td className="border border-gray-400 p-2">Broadcast Reach</td>
                  <td className="border border-gray-400 p-2">Only who have saved your number</td>
                  <td className="border border-gray-400 p-2">All Users</td>
                </tr>
                <tr>
                  <td className="border border-gray-400 p-2">Verified Green Tick</td>
                  <td className="border border-gray-400 p-2">Not Possible</td>
                  <td className="border border-gray-400 p-2">Yes</td>
                </tr>
                <tr>
                  <td className="border border-gray-400 p-2">Clickable Messages</td>
                  <td className="border border-gray-400 p-2">No</td>
                  <td className="border border-gray-400 p-2">Yes</td>
                </tr>
                <tr>
                  <td className="border border-gray-400 p-2">Analytics</td>
                  <td className="border border-gray-400 p-2">Not possible</td>
                  <td className="border border-gray-400 p-2">Get campaigns and agent analytics</td>
                </tr>
                <tr>
                  <td className="border border-gray-400 p-2">Workflows Setup</td>
                  <td className="border border-gray-400 p-2">No setup available.</td>
                  <td className="border border-gray-400 p-2">Setup custom and pre-configured workflows.</td>
                </tr>
                <tr>
                  <td className="border border-gray-400 p-2">Integration</td>
                  <td className="border border-gray-400 p-2">Not possible</td>
                  <td className="border border-gray-400 p-2">Integrate with 200+ existing CRM</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section>
      <section className="py-5 overflow-hidden">
        <div className="container">
          <div className="feature_content"
            data-aos="fade-left" data-aos-delay="300"
          >
            <h4>Why WhatsApp Marketing in Future?</h4>
            <p>WhatsApp is the One Platform that brings together Actionable Notifications & Customer Support!</p>
          </div>
          <div className="row">
            {percentageData.map((item, index) => {
              return (
                <div className="col-lg-3 col-md-6" key={index}>
                  <div className="feature_content">
                    <h4>{item.per}</h4>
                    <p>{item.name}</p>
                  </div>
                </div>
              )
            })}
          </div>
        </div>
      </section>
      <section className="py-5 overflow-hidden">
        <div className="container">
          <div>
            <h1 className="py-2 faqfont mb-5">FAQs - (WhatsApp Business API)</h1>
          </div>
          <div className="accordion" id="accordionExample">
            {itemsToShow.map((item, index) => (
              <div className="accordion-item border-top" key={index}
                data-aos={`fade-${index % 2 === 1 ? "down" : "up"}`} data-aos-delay="300"
              >
                <h2 className="accordion-header" id={`heading${item.id}`}>
                  <button
                    className={`accordion-button d-flex align-items-center ${index !== 0 ? 'collapsed' : ''
                      }`}
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target={`#collapse${item.id}`}
                    aria-expanded={index === 0 ? 'true' : 'false'}
                    aria-controls={`collapse${item.id}`}
                  >
                    <span className="me-3 toggle-icon"></span>
                    {item.question}
                  </button>
                </h2>
                <div
                  id={`collapse${item.id}`}
                  className={`accordion-collapse collapse ${index === 0 ? 'show' : ''}`}
                  aria-labelledby={`heading${item.id}`}
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body wrapfaq">{item.answer}</div>
                </div>
              </div>
            ))}
          </div>
          {whatsappBusinessApiFAQs.length > 10 && (
            <div className="text-center py-3 ">
              <button
                className="btn-sm viewbtn"
                onClick={() => setShowAll(!showAll)}
              >
                {showAll ? "View Less" : "View More"}
              </button>
            </div>
          )}
        </div>
      </section>
      <Joinus />
    </div>

</>
   
  );
};

export default WhatsappBusinessApi;
